





















import { Vue, Component, Watch, Prop} from 'vue-property-decorator';
import {namespace} from "vuex-class";
import Dialog from "@/views/Dialog/Dialog.vue";
import ShipmentInfo from "@/views/Dialog/views/ShipmentInfo.vue";
import {IHistoryShipment} from "@/models/StoreModels";

const historyModule = namespace("history");

@Component({
  name: 'DialogInfo',
  components: {
    Dialog,
    ShipmentInfo,
  },
})
export default class DialogInfo extends Vue {
  @Prop({ default: 0 })
  public shipmentId!: number;

  @historyModule.Action("loadShipment")
  public loadShipment!: (id: number) => Promise<any>;

  @historyModule.Getter("getCurrentShipment")
  public currentShipment!: IHistoryShipment;

  public loading: boolean = false;

  @Watch('shipmentId')
  public shipmentUpdate() {
    this.loading = true;
    this.loadShipment(this.shipmentId)
        .catch(() => this.showError())
        .finally(() => this.loading = false)
    ;
  }

  public closeDialog() {
    this.$emit("shipmentInfo:hide");
  }

  public created() {
    if (this.shipmentId  !== 0) {
      this.shipmentUpdate();
    }
  }

  public showError() {
    this.$uiBus.emit('genericError:show', this.$t('errors.shipment_load_error'));
    this.closeDialog();
  }
}
